export default "__VITE_ASSET__20dbdc92__"